import { useState } from 'react';
import { Link } from 'react-router-dom';
import { roundupStats, scoreRating, summaryLabels } from '../../../utils/roundup';
import { downloadRoundupImage } from '../../../utils/roundup-share';

export default function Finalise({ roundup, issues, tasks, blocked }) {
  const [finishing, setFinishing] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState('');
  const stats = roundup.roundup?.roundup_summary || roundupStats(roundup.goals, issues, tasks, roundup.roundup?._id);
  const finish = async () => {
    setFinishing(true); setError('');
    try { await roundup.finish(); }
    catch (error) { setError(error.response?.data?.message || 'Unable to finish your roundup. Please try again.'); }
    finally { setFinishing(false); }
  };
  const download = async () => {
    setDownloading(true); setError('');
    try { await downloadRoundupImage({ number: roundup.number, items: roundup.items, stats, completed: roundup.isCompleted }); }
    catch (error) { setError(error.message || 'Unable to download the summary image.'); }
    finally { setDownloading(false); }
  };

  return <div>
    <article className="roundup-summary" aria-label={`Roundup ${roundup.number} summary`}>
      <header className="roundup-summary__header"><span>HAMMER THE BACKLOG</span><h2>Roundup {roundup.number}</h2><p>{roundup.isCompleted ? 'A week of progress, saved.' : 'This week’s progress · Draft'}</p></header>
      <div className="roundup-summary__body">
        <div className="roundup-summary__stats">{summaryLabels.map(([key, label]) => <div key={key}><strong>{stats[key] || 0}</strong><span>{label}</span></div>)}</div>
        <h3>The scorecard</h3>
        {roundup.items.length ? <table><thead><tr><th>Metric</th><th>Aim</th><th>Actual</th></tr></thead><tbody>
          {roundup.items.map((item, index) => {
            const rating = scoreRating(item.value, item.aim);
            return <tr key={index}><th scope="row">{item.name}</th><td>{item.aim}</td><td className={rating.className}><strong>{item.value ?? 0}</strong><small>{rating.label}</small></td></tr>;
          })}
        </tbody></table> : <p>Progress starts with showing up.</p>}
        <footer>One week at a time. Hammer your backlog.</footer>
      </div>
    </article>
    {error && <p role="alert">{error}</p>}
    <div className="roundup-summary__actions">
      {!roundup.isCompleted && <button className="btn-solid-gray pill" disabled={blocked || finishing} onClick={finish}>{finishing ? 'Finishing…' : 'Finish Roundup'}</button>}
      <button className="btn-outline pill" disabled={blocked || finishing || downloading} onClick={download}>{downloading ? 'Creating image…' : 'Download roundup image'}</button>
      {roundup.isCompleted && <Link to="/">Back to Home</Link>}
    </div>
    {!roundup.isCompleted && <p>The image is marked as a draft until you finish the roundup.</p>}
  </div>;
}
